import axios from 'axios';
import { helperGetApiHeaders, helperConvertApiRoute } from 'helpers/ApiHelper';

export const FETCH_ARTICLE = 'FETCH_ARTICLE';

export function fetchArticle(url, accessToken, deviceId) {
  const pageType = 'articleDetail';
  const request = axios.get(
    helperConvertApiRoute(url),
    helperGetApiHeaders({ pathKey: pageType, accessToken, deviceId }),
  );

  return {
    type: FETCH_ARTICLE,
    payload: request,
  };
}
